import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { placeOrderNoAuth } from "../../../http/ordersAPI";
import CustomerDataInputs from "../CustomerDataInputs/CustomerDataInputs";
import DeliveryDataInputs from "../DeliveryDataInputs/DeliveryDataInputs";
import PaymentDataInputs from "../PaymentDataInputs/PaymentDataInputs";
import {
  getUserIsLoadingSelector,
  getUserSelector,
} from "../../../store/user/selectors";
import Loader from "../../../components/Loader/Loader";
import schema from "../schema";
import styles from "./CheckoutAuth.module.scss";
import {
  cartTotalPriceAction,
  saveCartAction,
  saveLocalCartAction,
} from "../../../store/cart/actions";
import { Button } from "react-bootstrap";
import { useMessageSuccess, useMessageError } from "../../../hooks/message.hook";
import { getLocalCartSelector } from "../../../store/cart/selectors";

const CheckoutAuth = () => {
  const [messageServer, setMessageServer] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [commentAvailible, setCommentAvailible] = useState(false);
  const customerLoading = useSelector(getUserIsLoadingSelector);
  const user = useSelector(getUserSelector);
  const messageSuccess = useMessageSuccess();
  const messageError = useMessageError();
  const { _id: id } = user || {};
  const [products, setProducts] = useState([]);
  const localCart = useSelector(getLocalCartSelector);
  const touchedRef = useRef(false);

  useEffect(() => {
    if (Array.isArray(localCart) && localCart.length) {
      setProducts(localCart);
    } else {
      navigate("/");
    }
  }, [localCart, navigate]);

  if (customerLoading) {
    return <Loader />;
  }

  return (
    <div className={styles.tabContainer}>
      <Formik
        initialValues={{
          firstName: user?.firstName || "",
          lastName: user?.lastName || "",
          phone: user?.phone || "+380",
          email: user?.email || "",
          region: null,
          city: null,
          delivery: { value: "Нова пошта", label: "Нова пошта" },
          address: null,
          paymentMethod: "MonoPay",
          monoPartsCount: "3",
          comment: "",
        }}
        validationSchema={schema}
        onSubmit={(values, { setSubmitting }) => {
          // if (values.paymentMethod === "MonoCredit") {
          //   messageError(
          //     "Оплата частинами monobank буде доступна після активації магазину банком."
          //   );

          //   setSubmitting(false);
          //   return;
          // }
          const status = "processed";

          if (!Array.isArray(products) || products.length === 0) {
            navigate("/");
            return;
          }

          const deliveryAddress = {
            delivery: values.delivery?.label || "",
            region: values.region?.label || "",
            city: values.city?.label || "",
            address: values.address?.label || "",
          };

          const ordersValue = {
            ...values,
            delivery: values.delivery?.label || "",
          };

          placeOrderNoAuth({
            ...ordersValue,
            deliveryAddress,
            userId: id,
            status,
            products,
          })
            .then((res) => {
              if (res.status === 200 || res.status === 201) {
                const pageUrl = res?.data?.data?.pageUrl;

                if (pageUrl) {
                  messageSuccess("Замовлення створено. Переходимо до оплати monobank.");
                  window.location.assign(pageUrl);
                  return;
                }

                messageSuccess("Замовлення успішно оформлене!");
                localStorage.setItem("cart", JSON.stringify([]));
                dispatch(cartTotalPriceAction(0));
                dispatch(saveCartAction([]));
                dispatch(saveLocalCartAction([]));
                navigate("orderAccepted");
              }
            })
            .catch((err) => {
              const apiMsg =
                err?.response?.data?.message ||
                (err?.response?.data ? Object.values(err.response.data).join(" ") : null);
              const errorMessage = apiMsg || "Виникла помилка при оформленні замовлення";
              setMessageServer(<span>{errorMessage}</span>);
              messageError(errorMessage);
            })
            .finally(() => {
              setSubmitting(false);
            });
        }}
      >
        {(formik) => {
          const onTouchStartSubmit = (e) => {
            touchedRef.current = true;
            e.preventDefault();
            formik.submitForm();
          };

          const onClickSubmit = () => {
            if (touchedRef.current) {
              touchedRef.current = false;
              return;
            }
            // нативний сабміт через type="submit"
          };

          return (
            <Form noValidate>
              <CustomerDataInputs formik={formik} />
              <h3 className="checkout__title">Доставка</h3>
              <DeliveryDataInputs />
              <hr />
              <h3 className="checkout__title">Оплата</h3>
              <PaymentDataInputs products={products}/>
              <hr />
              <div className={styles.addComment}>
                {!commentAvailible && (
                  <span
                    role="button"
                    className={styles.comment}
                    id="commentInvolver"
                    onClick={() => setCommentAvailible(true)}
                  >
                    Додати коментарій
                  </span>
                )}
                {commentAvailible && (
                  <div className={styles.textareaContainer}>
                    <label className={styles.label}>Коментарій</label>
                    <Field
                      as="textarea"
                      className={styles.textarea}
                      name="comment"
                      placeholder="Коментарій"
                      rows={5}
                    />
                  </div>
                )}
              </div>

              <Button
                variant="dark"
                type="submit"
                disabled={!Array.isArray(products) || products.length === 0 || formik.isSubmitting}
                onTouchStart={onTouchStartSubmit}
                onClick={onClickSubmit}
              >
                {formik.isSubmitting ? "Оформлюємо…" : "Оформити замовлення"}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default CheckoutAuth;
